import { createContext, useContext, useEffect, useState } from "react";
import { getEmployerCompanies } from "../pages/api/Employer/Employer";
import { getUserToken } from "../common/userfuctions";


const CompanyContext = createContext({
    companies: [],
    setCompanies: () => { },
})

export const CompanyProvider = ({ children }) => {
    const [companies, setCompanies] = useState([]);
    // useEffect(() => {
    //     const data = async () => {
    //         const UserToken = getUserToken();
    //         if (UserToken) {
    //             const response = await getEmployerCompanies()
    //             if (response?.Status) {
    //                 const comps = response?.Data;
    //                 if (typeof comps == 'object') {
    //                     setCompanies(comps.map(item => item?.FieldId))
    //                 }
    //             }
    //         }
    //     }
    //     data()
    // }, [])

    const value = { companies, setCompanies }
    return (
        <CompanyContext.Provider value={value}>
            {children}
        </CompanyContext.Provider>
    )
}

export const useCompanies = () => useContext(CompanyContext)